import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { GoalsIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutsItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <GoalsIcon size="xsmall" shouldUseNewLogoDesign />;

/**
 * @private
 * @deprecated Please use `useGoals` instead
 */
export default function goals(fallbackUrl: FallbackUrl): GlobalShortcutsItem {
	return {
		icon,
		// The i18n unfriendly default value of `label` is why this function is deprecated.
		// `labelElem` will be used instead of `label` in most places, but `label` will still be used in some places like customization modal.
		// For an i18n friendly default value of `label`, please use `useGoals` instead.
		label: 'Goals',
		labelElem: <FormattedMessage {...messages.label} />,
		apsKey: Products.ATLAS_GOALS,
		fallbackUrl,
	};
}

export const useGoals = (fallbackUrl: FallbackUrl) =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, { apsKey: Products.ATLAS_GOALS });
